import axiosInstance from '../config/axios';

export interface TaxOfficeDto {
  taxOfficeCode: string;
  taxOfficeDescription: string;
  cityCode?: string;
  districtCode?: string;
}

export interface ResolveTaxOfficeRequest {
  freeText: string;
  cityCode?: string;
  districtCode?: string;
  offices: TaxOfficeDto[];
}

export interface ResolveTaxOfficeResponse {
  code?: string;
  description?: string;
  score?: number;
  candidates?: Array<{ code: string; description: string; score: number }>;
}

export const aiApi = {
  async resolveTaxOffice(req: ResolveTaxOfficeRequest): Promise<ResolveTaxOfficeResponse> {
    const { data } = await axiosInstance.post('/api/v1/Ai/resolve-tax-office', req);
    return data;
  },
  async resolveLocation(req: { region?: string; city?: string; district?: string; taxOffice?: string }): Promise<{
    success?: boolean;
    data?: {
      regionCode?: string;
      regionDescription?: string;
      cityCode?: string;
      cityDescription?: string;
      districtCode?: string;
      districtDescription?: string;
      taxOfficeCode?: string;
      taxOfficeDescription?: string;
    };
  }> {
    const { data } = await axiosInstance.post('/api/v1/Customer/resolve', {
      region: req.region ?? null,
      city: req.city ?? null,
      district: req.district ?? null,
      taxOffice: req.taxOffice ?? null,
      countryCode: 'TR',
      langCode: 'TR'
    });
    return data;
  }
};
